// src/contexts/NotificationContext.jsx
import React, { createContext, useState, useCallback, useContext } from 'react';

const NotificationContext = createContext(null);

let idCounter = 0; // Простой счетчик для уникальных ID

export const NotificationProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);

    const addNotification = useCallback((message, type = 'info') => {
        const id = idCounter++;
        setNotifications((prevNotifications) => [
            ...prevNotifications,
            { id, message, type },
        ]);
    }, []);

    const removeNotification = useCallback((notificationId) => {
        setNotifications((prevNotifications) =>
            prevNotifications.filter((n) => n.id !== notificationId)
        );
    }, []);

    return (
        // ОБНОВЛЕНО: передаем notifications и removeNotification
        <NotificationContext.Provider value={{ notifications, addNotification, removeNotification }}>
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotifier = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotifier must be used within a NotificationProvider');
    }
    return context;
};

// Экспортируем сам контекст для использования в NotificationContainer
export { NotificationContext };
